import { ApplicationConfig, inject, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { provideStore } from '@ngrx/store';
import { AppConfirmBusService } from 'src/app/layout/services/confirm-bus.service';
import { AppToastBusService } from 'src/app/layout/services/toast-bus.service';
import { AppDialogService } from 'src/app/layout/services/app-dialog.service';
import { routes } from './app-routing.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { reducers } from './state/reducers';
import { TesteAwareTitleStrategy } from './core/services/teste-title-strategy.service';
import { DEFAULT_KANBAN_LABELS, KANBAN_FONT_SCALE, KANBAN_LABELS } from '@smart/kanban';
import { FontSizeService } from './core/services/font-size.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideIonicAngular({ mode: 'md' }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideServiceWorker('custom-service-worker.js'),
    provideAnimationsAsync(),
    provideStore(reducers),
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    AppConfirmBusService,
    AppToastBusService,
    AppDialogService,
    { provide: TitleStrategy, useClass: TesteAwareTitleStrategy },
    // Lib @smart/kanban: rótulos do board e escala dos ícones das colunas
    // (acessibilidade "Tamanho letras" — FontSizeService.scale é um Signal<number>).
    { provide: KANBAN_LABELS, useValue: { ...DEFAULT_KANBAN_LABELS, addCard: 'Adicionar imóvel' } },
    { provide: KANBAN_FONT_SCALE, useFactory: () => inject(FontSizeService).scale },
  ]
};
